/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Export types
 */
export enum ExportTypes {
	NAN = "NaN",
	DATE = "Date",
	SCHEMA = "Schema",
	VALIDATOR = "Validator"
}

export interface ISchemaImportExport {
	_type: string;
	_name: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	_values: any[];
}
